import type { SVGProps } from 'react';
const SvgBookOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <desc>{'Book Open 2 Streamline Icon: https://streamlinehq.com'}</desc>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.458 21.269a1.6 1.6 0 0 0 1.085 0 13.66 13.66 0 0 1 8.7-.448 1.607 1.607 0 0 0 2.006-1.559V4.928a1.61 1.61 0 0 0-1.12-1.528 13.88 13.88 0 0 0-9.586.2 1.6 1.6 0 0 1-1.085 0 13.88 13.88 0 0 0-9.587-.2A1.61 1.61 0 0 0 .75 4.928v14.334a1.607 1.607 0 0 0 2.006 1.559 13.66 13.66 0 0 1 8.702.448M12 3.682v17.682"
    />
  </svg>
);
export default SvgBookOpen;
